export enum InventoryEntryTypeEnum {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT',
  TRANSFER = 'TRANSFER',
  TRANSFER_IN = 'TRANSFER_IN',
  TRANSFER_OUT = 'TRANSFER_OUT',
}

export enum CostCenterEnum {
  SEEDING = 'SEEDING',
  FERTIGATION = 'FERTIGATION',
  PLANT_HEALTH = 'PLANT_HEALTH',
  MAINTENANCE = 'MAINTENANCE',
  GRAFTING = 'GRAFTING',
  QUALITY_ASSURANCE = 'QUALITY_ASSURANCE',
  LOGISTICS = 'LOGISTICS',
  FIELD = 'FIELD',
}

export enum InventoryOutputTypeEnum {
  PRODUCTION = 'PRODUCTION',
  ADJUSTMENT = 'ADJUSTMENT',
  DISCARD = 'DISCARD',
}

export enum InventoryTypeEnum {
  ORGANIZATION = 'ORGANIZATION',
  CLIENT = 'CLIENT',
}

type InventoryTypeDisplay = {
  name: string
}

export const InventoryTypeDisplayMapping: Record<InventoryTypeEnum, InventoryTypeDisplay> = {
  [InventoryTypeEnum.ORGANIZATION]: {
    name: 'Viveiro',
  },
  [InventoryTypeEnum.CLIENT]: {
    name: 'Cliente',
  },
};

export enum PriceTypeEnum {
  UnitPrice = 'UNIT_PRICE',
  TotalPrice = 'TOTAL_PRICE',
}

// export const InventoryEntryTypeMapping = {
//   [InventoryEntryTypeEnum.INPUT]: {
//     name: 'Entrada',
//   },
//   [InventoryEntryTypeEnum.OUTPUT]: {
//     name: 'Saída',
//   },
//   [InventoryEntryTypeEnum.TRANSFER]: {
//     name: 'Transferência',
//   },
// };

export const InventoryEntryTypeMapping = {
  [InventoryEntryTypeEnum.INPUT]: {
    name: 'Entrada',
  },
  [InventoryEntryTypeEnum.OUTPUT]: {
    name: 'Saída',
  },
  [InventoryEntryTypeEnum.TRANSFER]: {
    name: 'Transferência',
  },
  [InventoryEntryTypeEnum.TRANSFER_IN]: {
    name: 'Transferência',
  },
  [InventoryEntryTypeEnum.TRANSFER_OUT]: {
    name: 'Transferência',
  },
};

export const InventoryOutputReasonMapping = {
  [InventoryOutputTypeEnum.PRODUCTION]: {
    name: 'Produção',
  },
  [InventoryOutputTypeEnum.ADJUSTMENT]: {
    name: 'Ajuste',
  },
  [InventoryOutputTypeEnum.DISCARD]: {
    name: 'Descarte',
  },
};

export const InventoryCostCenterMapping = {
  [CostCenterEnum.SEEDING]: {
    name: 'Semeio',
  },
  [CostCenterEnum.FERTIGATION]: {
    name: 'Fertirrigação',
  },
  [CostCenterEnum.PLANT_HEALTH]: {
    name: 'Fitossanidade',
  },
  [CostCenterEnum.MAINTENANCE]: {
    name: 'Manutenção',
  },
  [CostCenterEnum.GRAFTING]: {
    name: 'Enxertia',
  },
  [CostCenterEnum.QUALITY_ASSURANCE]: {
    name: 'Qualidade',
  },
  [CostCenterEnum.LOGISTICS]: {
    name: 'Logística',
  },
  [CostCenterEnum.FIELD]: {
    name: 'Campo',
  },
};

// TODO: check and remove
export const InventoryTypeMapping = {
  [InventoryTypeEnum.ORGANIZATION]: {
    name: 'Viveiro',
  },
  [InventoryTypeEnum.CLIENT]: {
    name: 'Cliente',
  },
};

export type MenuEntryType = InventoryEntryTypeEnum.INPUT
  | InventoryEntryTypeEnum.OUTPUT
  | InventoryEntryTypeEnum.TRANSFER;
